import React from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import ForcePasswordChange from './ForcePasswordChange';

// Who may see a page: signed in, the password changed if it was a
// temporary one, a guard only in the guard portal, and the roles a page
// lists (allowedRoles). Moved out of App.js unchanged, plus the guard rule.
const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = React.useContext(AuthContext);

  if (loading) {
    return <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh' 
    }}>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  // After an admin reset, nothing else is usable until the password is changed.
  if (user.must_change_password) {
    return <ForcePasswordChange />;
  }

  // A guard (role employee) has only the guard portal: any other page,
  // including the start page after signing in, leads there.
  if (user.role === 'employee' && !(allowedRoles && allowedRoles.includes('employee'))) {
    return <Navigate to="/portal" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/dashboard" />;
  }

  return children;
};

export default ProtectedRoute;
